
//OTHER

/** Лимит запроса проектов на странице «Массовый экспорт» (GetList / грид) */
export const EXPORT_PAGE_PROJECTS_GRID_LIMIT = 999;

/** Максимум проектов, доступных для одного массового экспорта (выбор на странице) */
export const MANY_EXPORT_MAX_SELECTED_PROJECTS = 20;

export const AGEYTOMESH_TAG_ID = '124a3a674c3a4bcd8b9d86c9ef94ed8e';
export const HSEILLUSTRATION_TAG_ID = '9042e2d03e4e490b8c7effb0d2334cc4';
export const DURASOV_TAG_ID = '978b65c195764864qprd2d1f6vbty0bn';
export const STARTSUP_TAG_ID = 'bc3d74101226400b90885d1f5d5a850a';
export const VIDEO_ART_TAG_ID = '36eb670a9e774a3eba96d0a6e080d064';
export const MODERN_ART_TAG_ID = '5164b991a9d8469389175ceeb86d65b8';
export const EDUCATION_COURSE = 'c670d2358d4940fb8fede85e9e084bc8';
export const CINEMA_TAG_ID = 'cd7fbc104946470e872eb12d69343aeb';
export const LONGREAD_TAG_ID_BL = '4dfd07c2fdf04975aeee4f39c19b7ab0';
export const LECTURE_TAG_ID_BL = 'd2d175d64b3b491c812f303fb6db6271';
export const VIDEO_TAG_ID = '09f9c8a1bb094b7884e8f533f2a98c69';


// HSE ILLUSTRATION PAGE 

export const ILLUSTRATION_TAG_ID = '9042e2d03e4e490b8c7effb0d2334cc4';
export const ILLUSTRATION_IDENTIC_ID = '110b8bb6cb324f3ba7175966bc6fb92a';
export const BOOK_TAG_ID = '2687fadaf0e048ed9925e56052f3010e';
export const ANIMATION_TAG_ID = 'd4a9c6ee23c14a159cb8c363423adb2d';
export const ANIMATION_FOR_HSEPERM_TAG_ID = 'd4a9c6ee23c14a159cb8c363423adb2d_HSEPERM';
export const INFOGRAPHICS_TAG_ID = 'ebe67af45caf497e9fe1bf4b5886bb79';
export const FINE_ART_TAG_ID = 'df140c74barqwe1e3d883a590378812d77'; 
export const DIGITAL_ART_TAG_ID = 'df140c74barqwe1e3d883aqe13dxzd2124dxs1';
export const DIGITAL_ART_NEW_TAG_ID = 'df140c74barqwe1e3d883aqe13dxzd2124dxs';
export const ILLUSTRATED_BOOK_TAG_ID = 'f5d5782c8d57414f9cde4e6c1712205d';

export const PHOTOBOOK_TAG_ID = 'f3f6e3f02f304104bad3025a9ff1ecbb';
export const TYPOGRAPHY_TAG_ID = '770ae42eec5d46eb832732b36ca4845b';
export const TD_ENVIRONMENT_TAG_ID = '9869c3fc8dbf4ea89ea26891b33ba11a';
export const TD_ART_TAG_ID = '61445c2746b041ea93aaedbde9ccd043';
export const DULYOVO_PORCELAIN_TAG_ID = 'cc26219d26a343aba5d254174d0634e0';
export const PRINTED_GRAPHICS_TAG_ID = '314043c6cb3d41ebb99ef189f7fc90b9';
export const ART_OBJECT_TAG_ID = '5327d4433ee34a6d8359174eb5bac70c';
export const EXHIBITION_SPACE_TAG_ID = '0ced641086264011a3da659e58aefa01';
export const SCULPTURE_TAG_ID = '6m0caf276eb6422abffcc292412156a424';
export const INSTALLATION_TAG_ID = '79de7f5b0bf34dfcb19cf42ba2efe535';
export const ABSTRACT_EXPRESSIONISM_TAG_ID = '3885719946bd437ea5dcbc334dfe9a2b';

export const COMICS_TAG_ID = 'aa5c803117204bbcb6d4ade23174f8e6';
export const CONCEPT_ART_TAG_ID = 'b88663a9d30642c88a2c54253dad2746';
export const CGI_TAG_ID = '800135c9495641d994b18344753c8f61'

//HSE MAIN PAGE 

export const DESIGN_TAG_ID = '450b65c195424392bafd2d1f6ffbf8ed';
export const ART_TAG_ID = '3baf5ce908d84cc2a8ac6c2fcc5a9c45';
export const FASHION_TAG_ID = '64e62f92b5874bb6b37a1062682dcea7';
export const JEWELRY_TAG_ID = 'ba14bd8702064ea48c3fddf572e225c3';

export const CANTEMPORARY_ART_TAG_ID = '5164b991a9d8469389175ceeb86d65b8';
export const PHOTOGRAPHY_ART_TAG_ID = 'e2108241611c4ee4861bb511faecdb5f';
export const VIDEO_ART_ART_TAG_ID = '36eb670a9e774a3eba96d0a6e080d064';
export const CURATOR_TAG_ID = 'a9b0cca1e0504713b73d8c4f9c85223c'

export const ADVERTISING_TAG_ID = '1b374fc6d2aa4f3696a3558b324bca31';
export const ART_DIRECTION_TAG_ID = 'ffa06d1b16b54abba2bbf6c8fb7eaf6d';
export const WEB_PUBLISH_TAG_ID = '89412f173a904356beb8e25f74ff2b73';
export const BOOK_DESIGN_TAD_ID = '2687fadaf0e048ed9925e56052f3010e';
export const BASIC_DESIGN_TA_ID = '0ea8c1fd2f6e49c3839c29fa10bc93b0';

export const COMMUNICATION_TAG_ID= '9bbc6e63198244efb2f6e586898f8f84';
export const NATURE_DESIGN_TAG_ID = '4f38a1e40a5f41cb9323dcbe3cea555d';
export const INTER_DESIGN_TAG_ID = '80fa55ae7d414e2eb90a170b62c1cce2';
export const CREATIVE_PROGRAMMING_TAG_ID= '36e3fd69fede4f9fb4f84d1be90a9e91';
export const DIGITAL_PRODUCT_TAG_ID= 'f0f14e99db1c4e25b889e87db45a73a0';
export const INTERACTIVE_DESIGN_TAG_ID= '269d0812d0d84d4ca64faaea4f3b88cc';
export const MEDIA_DESIGN_TAG_ID= '8972f434446b43c49dd0db38f5e8e376';
export const MODERN_DESIGN_TAG_ID = 'c670d2358d4940fb8fede85e9e084bc8';
export const OBJECT_DESIGN_TAG_ID = '47ae888ae5fe4343ad29999d04829b44';
export const PACKAGING_TAG_ID = '52644f0d0d9d4a2ea47192e70310ec12';
export const TYPE_TAG_ID = '55cc44daca804b979d067f9a59c56e00';
export const PRINT_PRODUCT_TAG_ID = '3ff5db4e9ed74d91869a35b36826fce3';
export const MANU_DESIGN_TAG_ID = 'd7cb4af8a1a861b2a25s79s914a2f2d8d';

export const RUSSIA_TAG_ID = '77b185c6f4ed4c1495cf8e165b0d1e5f';
export const EU_TAG_ID = 'eu';

//HSE LAB PAGE

export const HSELAB_DESIGN_TAG_ID = "450b65c195424392bafd2d1f6ffbf8ed_HSELAB"
export const EVENTS_DESIGN_TAG_ID = "a811d3a5afc04787a077199f1a969ad2"
export const BRAND_TAG_ID = '4f11ba61f96747f797c4d73421240810';
export const INTERIOR_TAG_ID = '070de8dee76e4712ac1f884d4275cb8e';
export const DESIGN_EDUCATION_TAG_ID = 'e0eee15578174c60863151f9ae9269c1';
export const REGIONS_TAG_ID = 'e0eee15578174c60863151f9ae9269c1';
export const PUBLIC_PLACE_ID = 'd82499c511b54aa195656cfb8eb52baf';
export const LANDSCAPING_TER_ID = 'b0479f308fb245c88020c5d884e2f7d6';
export const INTERIOR_DESIGN_TAG_ID = '80fa55ae7d414e2eb90a170b62c1cce2';


export const URBAN_ENVIRONMENT_ID = 'b5ecc76d50564c318b1ccd64fb257d9e';
export const TERRITORIAL_BRANDING_ID = '9237e556118a4585955a4d3342196a7d';
export const NATION_CRAFT_TAG_ID = '977b986e706b46ff9e8b809c700a9c5d';
export const CITIES_TAG_ID = 'dc762a78dac54369b91542bcbe86bb2a';
export const PLACES_TAG_ID = 'e0b6ceb6189b47e28c0257ae9f133d3d';


//Коллаб

export const COLAB_ID = 'cc1deeae3e7642d0858f6a39d553e370';
export const FASHION_COLAB_ID = 'f3e3a3f3bad345ef8dafb31667a24197';

//Издательство / книги

export const BOOK_DESIGN_ID = '2687fadaf0e048ed9925e56052f3010e';
export const MULTIPAGE_EDITION_ID = '549901e2e9f24e38a0b66bcbf7903c88';
export const CHILD_BOOK_ID = '1ea5957f54994f3b85450baf6837c134';
export const BOARD_GAME_ID = '334cd3a3f6584d0496b4a93179f42fc8';
export const VIMMELBUH_ID = 'ccfa83fc47bc44b78b6f077fcc403063';
export const CALENDAR_DESIGN_ID = 'beb0c95a01724cd0b4dd50d423f7f3d2';



//Галерея

export const CURATOR_ID = 'cfa985de99314540956c6703b4a866b3';
export const VIRTUAL_ID = 'e96d995e519740f1bf46d2f48a518555';
export const PICTURE_BOOK_ID = '0ea7259412644d8b830506f0fac2b08f';
export const PERFORMANS_ID = '04542772d26b4f21bcf963a06411826b';
export const PUBLIC_ART_ID = '75435409afdc4b9ca4615d1a4172688b';

export const GALLLLERY_ART_DIGITAL_COLLECTIONS_TAG_ID = '7eeaa5952fa8408ca9042ddbad24a542'; // цифровые коллекции
export const GALLLLERY_ART_COLLECTIONS_TAG_ID = 'df542139259049fc877f8ef761a83326'; // коллекции
export const GALLLLERY_ART_COLLECTING_TAG_ID = 'c88b2f098ff2456aae43e13d55876b04'; // коллекционирование
export const GALLLLERY_ART_ABOUT_COLLECTIONS_TAG_ID = 'e31b794d21364d87965942a45cab0ec0'; // о коллекционировании

/** Теги для табов «Проекты» / «Книги» в профиле Kiiids Art */
export const KIIIDS_ART_PROFILE_TAG_IDS = [
  '9d556f398293425da8cf551913e045c9',
  'b8f437190cc84e00b044542f91c661f2',
  'd5914f3b8bb547bab3cdd8ec0d6db1ec',
];

// категория исследования
export const RESEARCH_CATEGORY_ID = '5c0e423eed054a5b9970c54d1d9796fd';

//Визуальные исследования

export const DESIGN_HISTORY_ID = 'c578bf60a3c94a00a460022812834272';
export const ART_HISTORY_ID = 'd668fc391e9447f2b5a774d45a63b56f';

export const VISUAL_RES_TAG_ID_BL = 'b85dd5a16fcd41cf87e292d5733d660f';
export const VISUAL_RESEARCH_TAG_GRADUATION_BLACK = '3h8ecj38fk554a5j439bm4l4ch27dh3g';
export const VISUAL_RESEARCH_TAG_GRADUATION_WHITE = '3h8ecj38fk554a5j439bm4l4ch27dh3g';
export const VISUAL_RESEARCH_TAG_ASPIRANT = 'f9321d1337744e44831048435055ae54';
export const PRODUCT_RESEARCH_TAG = 'acb2f5d0e759439c8cd5aec44a1d8265';

//ALUMNI
export const EVENTS_TAD_ID = 'df1d2c2c367b429fa3c85b17132a73ad';
export const FANTASY_TAG_ID = '21b88acfd57f456985d37136a313f3cc';
export const SPACE_TAG_ID = '61857017874a45f5bfe698188fde91b0';
export const UNIVERSITY_TAG_ID = '009c939ebdc34eb4801246557e49979f';

//ART GEO
export const ARTIST_TAG_ID = 'b0b2ee60d6654ed7958c76af78f36b56';
export const GALLERYS_TAG_ID = '3baf5ce908d84cc2a8ac6c2fcc5a9c45_NEW';
export const HSE_ART_TAG_ID = '92a018084fac46f1b0e12646f8c1fda4';

/*______________ОРГАНИЗ____________ */
//HSE PERM
export const BASE_COURSE_ANIMATION_TAG_ID = '872a2bab9f6d4516b989755f72f03fbe';
export const GAME_DESIGN_TAG_ID = '56a474abc8e1448d96a536a9c584141f';
export const DESIGN_HSEPERM_TAG_ID = '450b65c195424392bafd2d1f6ffbf8ed_HSEPERM';
export const BASE_COMMUN_DESIGN_TAG_ID = '0ea8c1fd2f6e49c3839c29fa10bc93b0';

//PACKAGINGLAB
export const FOOD_PACKAGINGLAB_TAG = 'packaginglab_food_tag';
export const BEVERAGE_PACKAGINGLAB_TAG = 'packaginglab_beverage_tag';
export const BODY_PACKAGINGLAB_TAG = 'packaginglab_body_tag';
export const FOOD_PACKAGINGLAB_TAG_ID = '457816s3ab4ab22b129ad28sds4ac21e1';
export const BEVERAGE_PACKAGINGLAB_TAG_ID = '72751b12s628ab4a23d1e19asds4fc21';
export const BODY_PACKAGINGLAB_TAG_ID = '561cb4ab2f28a1a8sd52s78d994a21c4s';

//ADDCODINGHUB
export const ADCODINGHUB_TAG = 'adcodinghub_tag';

//AI LAB
export const AILAB_TAG = 'ailab_tag';
export const AI_TAG_ID = '2ed0d4a42307c1d9106e21a592e4704f';

//HSE FONTS 
export const HSEFONTS_TAG = 'hsefonts_tag';

//PRINTING HOUSE 
export const PRINTING_HOUSE_TAG = 'hseprintinghouse_tag';

//HSE MULTIMEDIA 
export const HSEMULTIMEDIA_TAG = 'hsemultimedia_tag';
export const EXPLAINERS_TAG_ID = '03eecb2abc0e47ac8ff99259ee35f27d';
export const TVDESIGN_TAG_ID = 'fa79ce7d6b5348faaad4695c53362aae';
export const MUSIC_CLIPS_TAG_ID = 'c0899462b2034748964b550c2a6e6a48';
export const DDD_POST_PROD_TAG_ID = 'v67b674c536843d7b987t9b397tb214f';

//TERBRANDING
export const TERBRANDING_TAG = 'terbranding_tag';

//HSE POSTER
export const HSEPOSTERLAB_TAG = 'hseposterlab_tag';
export const POSTER_TAG_ID = 'dddca0c7066a492a9ea553aca554ab7c';
export const AD_POSTER_TAG = '59a5a66097a340909a1476a65bff92d4';
export const SOCIAL_POSTER_TAG = '16592c4c71cf41fc8e5b9433075ebf4f';
export const THEATER_POSTER_TAG = '4499dff296ef4e66addc61295481ca82';

//HSE SCREENS
export const HSESCREENS_TAG = 'hsescreens_tag';

//HSECOLLECTIONS 
export const HSECOLLECTION_PORCELAIN_TAG = 'hsecollection_porcelain_tag';
export const HSECOLLECTION_TEXTILE_TAG = 'hsecollection_textile_tag';
export const HSECOLLECTION_SILCSCREEN_TAG = 'hsecollection_silcscreen_tag';
export const HSECOLLECTION_STORE_TAG = 'hsecollection_store_tag';
export const HSECOLLECTION_PRINT_TAG = 'hsecollection_print_tag';
export const HSECOLLECTION_CALENDARS_TAG = 'hsecollection_calendars_tag';

export const HSECOLLECTION_PORCELAIN_TAG_ID = '1783504c472b4ac38473855b083490ec';
export const HSECOLLECTION_TEXTILE_TAG_ID = 'ca97b342721e476aa6719b9e04919eac';
export const HSECOLLECTION_SILCSCREEN_TAG_ID = '51e780242cb6430385ca3c03e4fe038d';

export const HSECOLLECTION_CALENDARS_TAG_ID = '917a4684ad9541a0a80b8d1b84a8f8a8';

//HSEPHOTOLAB
export const HSEPHOTOLAB_TAG = 'hsephotolab_tag';

//EDUDESIGN
export const EDUDESIGN_TAG = 'edudesign_tag';
export const EDU_BRANDING_TAG_ID = 'a62f3c69ed474939aa9105590dbfdbf4';
export const CAMPUS_TAG_ID = 'cb97ab8c072a4f7abadd32e8116b4f65';



//CREATIVE
export const BASIC_DESIGN_COURSE_TAG_ID = '978saa51s67df76432e70310be98';
export const CREATIVE_BU_TAG_ID = '6ea17f37f26c40a3a606a1a0b1b33e1c';
export const TRANSPORT_TAG_ID = '8c430dfe72324740b4051ebb10d76867';
export const INDUSTRY_TAG_ID = '8a38819bf9c44033bf022b6031637e7a';
export const TOUR_TAG_ID = 'dc5606d3832840128de06f9249a8c330';
export const BRANDS_TAG_ID = '0e2dba66da304ceea31e119cd3144b6f';
export const HISTORY_INVESTIGATE_TAG_ID = 'cd99adea29d341f5b68485b3f9ff27db';

//PLACES
export const AUSTRIA_TAG_ID = '09533b9ebaeb4c3ba9a16265826d1eb1';
export const GB_TAG_ID = 'c54b14f23edf41008057afbdab87ff46';
export const GER_TAG_ID = 'bd99ff4af2234f25b7f29784b7d7934e';
export const IRL_TAG_ID = '612fa48d287946a2b16487d91a71e854';
export const LIHT_TAG_ID = 'a44e440072814423a95e3ed4c89ff4de';
export const LUX_TAG_ID = '619bd96bf5ec4e47b133daddadba5513';
export const FR_TAG_ID = '1556f863d9ee49778320847531954d27';
export const SWISS_TAG_ID = 'fa6b9656452f46d09b9327e68ed5c628';
export const ISL_TAG_ID = 'c92d427be8ef4c6ab4ed5626a4b0288a';
export const POL_TAG_ID = 'd1eb6d1ca28c446695352b5455f5d1f7';
export const NOWR_TAG_ID = '550ba04946db4e97879249284db7f980';
export const FINL_TAG_ID = 'ddda62b53d8a4d54860691c0c59eacfa';
export const SWE_TAG_ID = 'ce371d0aaa534f29b0f8a127ef2e2cc3';
export const SPAIN_TAG_ID = '07ea43a138f644ff94f9f5b8ec8a6d38';
export const IT_TAG_ID = '51178cbcd6e24c83a628125f3f798ca2';

//FOOD
export const FOOD_TAG_ID = '4e9f6f2a028e469893306a9c3e58c539';
export const RUS_FOOD_TAG_ID = 'f8446f2598b8426b8bd87917fe887c19';
export const GOR_FOOD_TAG_ID = '95eae18bc342465291d603cb29eb5810';
export const JAP_FOOD_TAG_ID = '78b3d2058a0a46cca13d8505b2c02027';
export const IT_FOOD_TAG_ID = 'bd9c90ec82814a0590e7a0cbf1a4bc7f';
export const FR_FOOD_TAG_ID = 'b9855d34aa3f43de815dcbca05f31bf1';
export const CHI_FOOD_TAG_ID = 'e221be608dd547b0ac7bd0f406ce537a';
export const SPA_FOOD_TAG_ID = 'bdb77f09a116495890e7c4372f6782ee';
export const MEX_FOOD_TAG_ID = '126cd4d4ac0d41ca9b76ffb1a6e2ac58';
export const IND_FOOD_TAG_ID = '0e52cc4e079b4a62af24b30bdcbbcf5d';
export const TUR_FOOD_TAG_ID = 'ec48cda820024a04baa027de2165348b';
export const AR_FOOD_TAG_ID = '57d0b5311bd8459994dcb09a70a873cc';
export const TAI_FOOD_TAG_ID = 'f81583951370453c8ea08ccaf2853fe3';
export const KOR_FOOD_TAG_ID = '583dbe0458da4cdcae9cfe0dcb579e07';
export const AFR_FOOD_TAG_ID = 'b3bf728ea8344c64bd56b68893cfadf0';
export const RESTAURANT_TAG_ID = '067e7fc3d51e44bf8d91ef7e02d6aa54';
export const CAFE_TAG_ID = '6c71101dc7bb48edaed9c519edf1e99a';
export const CONTEMPORARY_ART_TAG_ID = '5164b991a9d8469389175ceeb86d65b8';
 

//события
export const CONF_TAG_ID = '00a68ac85a0e474985d37136a313f3bb';
export const FEST_TAG_ID = '3859c2a874cd4fcc8982995bc23fffda';
export const PERFORMANCE_TAG_ID = 'e3fdeca5f3aa47f485300ea15eee4e9b';
export const THEATER_AND_PERF_TAG_ID = 'e1422025280f4aee8a6b69ecb78247e4';
export const SHADOW_THEATRE_TAG_ID = 'c0c4895b14e642b4a0fbc471d0d3a35c';
export const FESTIVAL_TAG_ID = 'd695b64fa924436197197838534cc829';
export const SHOW_TAG_ID = '6a8a43782ea04a2192d0418809d3666a';
export const EVENT_MANAGER_TAG_ID = '55aad37c3cac415791c3e5ccc6e98158';
export const MEDIA_STARTUP_TAG_ID = 'd4de303ca64349349889ce1fe6fdc1f6';
export const PRODUCER_TAG_ID = '92a5503dbafe48f482e7e281d687264c';
export const PERFORM_ART_TAG_ID = '422b4bcf2b2f41c9a73f72409c61e1ed';
export const BRAND_CONCEPT_TAG_ID = '1bb342481edf4c28b2ca1be17fa5cc7a';
export const ARCHITECT_TAG_ID = 'c1e7071d86004544a497fd305b38467c';

//RESEARCH
export const RESEARCH_TAG_ID = '5c0e423eed054a5b9970c54d1d9796fd';
export const THEMES_TAG_ID = 'a740e2f4ed044a7e81b6732f68bd74ac';
export const ALL_RESEARCH_TAG_ID = 'all_research';

//SOUND
export const SOUND_TAG_ID = '30e39c2e27fb430cbe541d94eb32d1ea';
export const SOUND_ART_TAG_ID = '30e39c2e27fb430cbe541d94eb32d1ea';

//---------Creative city

//Люди
export const PEOPLE_TAG_ID = 'db9d4954c3354147b496d8098b1cc096';

//Культура 
export const CULTURE_TAG_ID = 'culture_tag_id';
export const ARCH_TAG_ID = 'c1e7071d86004544a497fd305b38550d';
export const MUSEUM_NEW_TAG_ID = '370972265d64431f9b9a8d1085474ea5';
export const MUSEUM_TAG_ID = 'b233488ebb364517b0acfdece809b3b6';
export const LIBRARY_TAG_ID = '8ba964314ecd4d10b70693f5322605d1';
export const LIT_TAG_ID = '51069562a18341c2a968889727034174';
export const MUSIC_TAG_ID = '8db18d7413d74ab7a8e7aac29cfa3b25';
export const THEATRE_TAG_ID = '80f8067e3db745d3985740ccc30d3d5a';
export const EXPOSITION_TAG_ID = 'd85cb74227a841998fa2aa18843ad35b';

export const MUSEUM_BRANDING_TAG = '68204c511ef646fca24c45c662ad45b7';
export const MUSEUM_DESIGN_TAG = '83eaf8d8f9424d54809738bda258cbd7';

//Экономика
export const FINANCE_TAG_ID = '3d51f447146549d5b138dbf0fcdca198';

//Природа
export const NATURE_TAG_ID = '9cca20c1a528418a87c1698910fc4bc0';
export const ECOLOGY_TAG_ID = '3c9f57bafaf8441ca446b7cada10d271';
export const FLORA_AND_FAUNA_TAG_ID = '28d11df2496f42d0a31f4a76dd032a55';

//Спорт
export const SPORT_TAG_ID = 'de086b71f91b47fbab5b4e4c3a6ee311';

//Кулинария
export const CREATIVE_COOK_TAG_ID = 'cooking_tag_id';
export const COOKING_ID = '4e9f6f2a028e469893306a9c3e58c539';

//Праздники 
export const HOLIDAYS_TAG_ID = '4a2f0bd881284e9caa56df4d19432d0e';

//Менелдмент
export const MANAGEMENT_TAG_ID = 'management_tag_id';
export const BASE_DESIGN_COURSE = '978saa51s67df76432e70310be98';
export const CREATIVE_FUTURES_TAG_ID = '1d625ab4752s346f218asd3e19bcae1241';
export const FASHION_MANT_TAG_ID = 'fashion_managementidtag_id'
export const DESIGN_FUTURES_TAG_ID = 'design_futures_tag_id';
export const GAME_FUTURES_TAG_ID = 'game_futures_tag_id';
 
//CGLAB
export const D_PERSON_TAG_ID = '3753939a7998461cb5db26638e30ef6e';
export const D_MODEL_TAG_ID = '5c3ef460cb0a4f938afebfd883a62043';
export const VIDEO_GAME_TAG_ID = 'b3e32426e8ed45c38920e246c1ef9be0';
export const GAME_GRAPHIC_TAG_ID = '1e82c78705dd422588de261ca3c833ba';
export const ANIMATIC_TAG_ID = '1567199edb5e4baf8bfd84c4a5dd7a13';

//SOUND HSE
export const PRODUCTION_TAG = 'production_tag_id';
export const ARRANGEMENT_TAG_ID = '5077965390294678abe403b4bfc61c0c';
export const VOCAL_MUSIC_TAG_ID = 'cbadabb5401f40c0895335bbdfb9f463';
export const CLASSIC_MUSIC_TAG_ID = '085731fdb0cc407fa795477601fdb9aa';
export const MIX_TAG_ID = 'c4ba84b4c45d486a9a9f6e9a2ea9c05f';
export const MUSICAL_COMPOSITION_TAG_ID = 'c08eb0223c0346f8a5975f180dea871e';
export const MUSICAL_ALBUM_TAG_ID = '8f236b5d18b645c8bb297660eb75adf5';
export const POP_MUSIC_TAG_ID = '4f6c5853dc864ad6a7f35a0840921bb5';
export const ROCK_MUSIC_TAG_ID = '0f7e98cfdd6643538c26c21f57d8d160';
export const MIXING_AND_MASTERING_TAG_ID = '29650ab7f4e24346b3abde862b4c5442';
export const DANCING_MUSIC_TAG_ID = '9aabd60996494812bb8f9d6ec5cfcfeb';
export const INSTR_MUSIC_TAG_ID = '2eec68b59350449086b4f0bf68b3080a';

export const SOUND_PRODUCTION_TAG_ID = '1181e411d7c041db9814cb3e4cbc52d2';
export const MUSICAL_PROJECT_TAG_ID = 'ed8c09defea44566972b3415f62d3d0c';
export const STUDIO_RECORDING_TAG_ID = '4d216688eb4f44ff9ed423c2f664e51f';
export const ORCHESTRA_TAG_ID = 'dcd9c9f5378a418abfb8f0e9c40a4730';
export const PRESS_PACK_TAG_ID = 'f20edcf3c8f04b5598abd45f3b51cf18';
export const SOUND_SINTHESIS_TAG_ID = '2c9452a4159347359e3b0022f172a92d';
export const AUDIOMEDIA_TAG_ID = '8aeee03af2084ae6afdb3aa5c390fbb3';

export const SOUND_DESIGN_TAG = 'sound_design_tag_id';
export const SOUND_IDENTITY_TAG_ID = 'c7fac31f13e84a099d287f5dac833a18';
export const AUDIO_BRANDING_TAG_ID = 'eb8f149d8ef2469dae5be7331e856532';
export const SOUND_LIBRARY_TAG_ID = '8c6324f83161432eb1756c11b32956e0';
export const ANIMATION_MUSIC_TAG_ID = '726a44sd2154b63d1253cde21464cad194';
export const FILMS_MUSIC_TAG_ID = '726a44sd2154b63d1253cde21464cad193';
export const CATWALK_MUSIC_TAG_ID = '404c8a867aed4c50a62b3d944bd5e805';
export const ADVERTISING_MUSIC_TAG_ID = '1e2366394f8345fe904262f7b9eac785';
export const THEATRE_MUSIC_TAG_ID = '726a44sd2154b63d1253cde21464cad192';
export const PATCH_TAG_ID = '152f46e82b3e48a9b94c0b3a66a01931';
export const SOUND_TRACK_TAG_ID = '62d57b0a33f9490d9a179e824e19de0f';
export const BACKGROUND_MUSIC_TAG_ID = '9e9ddea7ef5c460caa7b99f0f86729b8';
export const FUNCTIONAL_MUSIC_TAG_ID = 'aa22168be44d4fac855cf43de85c516f';
export const SOUND_DESIGN_TAG_ID = '3c952dbe994742aea0ad2e2c6d22cba6'
export const BASE_COURSE_MODERN_DESIGN_TAG_ID = '140cdf7r1e3d8aq83e13qwedx14ba';

export const SOUND_ART_TAG = 'sound_art_tag_id';
export const SOUND_ALL_TAG = 'sound_all_tag-id';
export const SOUND_INSTALLATION_TAG_ID = 'b08893ecb1ba492f9d8fb0dbb532c9ec';
export const SOUND_SCULPTURE_TAG_ID = '514078bf2d0e46a5a2d938468a5b4864';
export const MULTI_INSTALLATION_TAG_ID = '5e590f63554146879aa20cc59834309d';
export const MULTIMEDIA_PERFORMANCE_TAG_ID = 'da215943b2aa47c49b84cc6a0d8806b3';
export const FIELD_RECORDS_TAG_ID = 'a9a1c45848aa4b3387d025cac5e6237a';
export const EXP_MUSIC_TAG_ID = 'ea318604d6ee4b7c961f8c7b60699250';
export const ELECTROACOUSTIC_MUSIC_TAG_ID = '97ad85557c6b4052aa6b6cd22ec08a8c';

export const SOUNDART_TAG_ID = 'e9e9e9278fa54708ba7e473383c8e39b';
export const NOISE_MUSIC_TAG_ID = 'dc1d6fa4b43740bfba32c5b822302a0b';
export const MUSIC_PRACTICE_TAG_ID = '18018226052142209f3d2a5e600d3d1d';
export const SOUNDSCAPE_TAG_ID = 'd045acaf08594097a6e099a14edbd051';
export const SONIFICATION_TAG_ID = '658ae9221ab54f0abe51bddf2d9cf70d';
export const ALHORITMIC_MUSIC_TAG_ID = 'f3f0013271e24c718a5c1a39832a4c48';
export const SOUND_POETRY_TAG_ID = 'dac19d25fd7c4635bf0db64ef9bc3e84';
export const MUSIC_CONCRETE_TAG_ID = '953bef3e80f64ef5ba1f53dbe2454749';

export const STUDIES_TAG = 'studies_tag_id';
export const SOUND_STUDIES_TAG_ID = '75e8252ef8134ca7a555cab6fad59895';
export const MUSICAL_CRITICISM = 'a3ff4048ab09452885cf0b7c1fc2c4b9';
export const SOUND_PHILOSOPHY = '30edfda170d14b59b004825c4ada05a6';
export const SOUND_ECOLOGY_TAG_ID = '3b1029f984dd458aa680e234ee197f37'

export const ABOUT_MUSIC_TAG_ID = '5f9874c63c814f9090a8a05634847da1'
export const MUSICIANS_TAG_ID = '3af0463f2dc342bab9e80a486187394e'

export const SOUNDLAB_TAG = 'sound_lab_tag_id';
export const MUSICAL_LABEL_TAG_ID = '6961eedbdbc54267aba10ee5b4bbc9f7';
export const SOUNDLAB_TAG_ID = '2f1deea7292a4441a66e56c8fe1e87ab';

export const ORIGINAL_FONT_TAG_ID = 'b21a771c9bca26f29sdaf4d2d88a5148a';

// HSE LMS

export const PRESENTAION_TAG_ID = '6878d529af2048a19d1f5d0d3ead2cc6';
export const EDUCATION_DESIGN_TAG_ID = '993cea0d707245d39455c29056a8f8f0';


export const FASHION_PHOTOGRAPHY_TAG_ID = '104062a4181242f1bfb9f0ac26ac6d95';
export const GAME_DEVELOPMENT_TAG_ID = '49eed1510eb9466296b337d0516bab94';

export const ABOUT_ART_TAG_ID = '325296fc9b3442c7b7ddbf0ef334d164';

export const AGEYTOMESH_LOGO_LENGTH = 182;
//OTHER

/** Лимит запроса проектов на странице «Массовый экспорт» (GetList / грид) */
export const EXPORT_PAGE_PROJECTS_GRID_LIMIT = 999;

/** Максимум проектов, доступных для одного массового экспорта (выбор на странице) */
export const MANY_EXPORT_MAX_SELECTED_PROJECTS = 20;

export const AGEYTOMESH_TAG_ID = '124a3a674c3a4bcd8b9d86c9ef94ed8e';
export const HSEILLUSTRATION_TAG_ID = '9042e2d03e4e490b8c7effb0d2334cc4';
export const DURASOV_TAG_ID = '978b65c195764864qprd2d1f6vbty0bn';
export const STARTSUP_TAG_ID = 'bc3d74101226400b90885d1f5d5a850a';
export const VIDEO_ART_TAG_ID = '36eb670a9e774a3eba96d0a6e080d064';
export const MODERN_ART_TAG_ID = '5164b991a9d8469389175ceeb86d65b8';
export const EDUCATION_COURSE = 'c670d2358d4940fb8fede85e9e084bc8';
export const CINEMA_TAG_ID = 'cd7fbc104946470e872eb12d69343aeb';
export const LONGREAD_TAG_ID_BL = '4dfd07c2fdf04975aeee4f39c19b7ab0';
export const LECTURE_TAG_ID_BL = 'd2d175d64b3b491c812f303fb6db6271';
export const VIDEO_TAG_ID = '09f9c8a1bb094b7884e8f533f2a98c69';


// HSE ILLUSTRATION PAGE 

export const ILLUSTRATION_TAG_ID = '9042e2d03e4e490b8c7effb0d2334cc4';
export const ILLUSTRATION_IDENTIC_ID = '110b8bb6cb324f3ba7175966bc6fb92a';
export const BOOK_TAG_ID = '2687fadaf0e048ed9925e56052f3010e';
export const ANIMATION_TAG_ID = 'd4a9c6ee23c14a159cb8c363423adb2d';
export const ANIMATION_FOR_HSEPERM_TAG_ID = 'd4a9c6ee23c14a159cb8c363423adb2d_HSEPERM';
export const INFOGRAPHICS_TAG_ID = 'ebe67af45caf497e9fe1bf4b5886bb79';
export const FINE_ART_TAG_ID = 'df140c74barqwe1e3d883a590378812d77'; 
export const DIGITAL_ART_TAG_ID = 'df140c74barqwe1e3d883aqe13dxzd2124dxs1';
export const DIGITAL_ART_NEW_TAG_ID = 'df140c74barqwe1e3d883aqe13dxzd2124dxs';
export const ILLUSTRATED_BOOK_TAG_ID = 'f5d5782c8d57414f9cde4e6c1712205d';

export const PHOTOBOOK_TAG_ID = 'f3f6e3f02f304104bad3025a9ff1ecbb';
export const TYPOGRAPHY_TAG_ID = '770ae42eec5d46eb832732b36ca4845b';
export const TD_ENVIRONMENT_TAG_ID = '9869c3fc8dbf4ea89ea26891b33ba11a';
export const TD_ART_TAG_ID = '61445c2746b041ea93aaedbde9ccd043';
export const DULYOVO_PORCELAIN_TAG_ID = 'cc26219d26a343aba5d254174d0634e0';
export const PRINTED_GRAPHICS_TAG_ID = '314043c6cb3d41ebb99ef189f7fc90b9';
export const ART_OBJECT_TAG_ID = '5327d4433ee34a6d8359174eb5bac70c';
export const EXHIBITION_SPACE_TAG_ID = '0ced641086264011a3da659e58aefa01';
export const SCULPTURE_TAG_ID = '6m0caf276eb6422abffcc292412156a424';
export const INSTALLATION_TAG_ID = '79de7f5b0bf34dfcb19cf42ba2efe535';
export const ABSTRACT_EXPRESSIONISM_TAG_ID = '3885719946bd437ea5dcbc334dfe9a2b';

export const COMICS_TAG_ID = 'aa5c803117204bbcb6d4ade23174f8e6';
export const CONCEPT_ART_TAG_ID = 'b88663a9d30642c88a2c54253dad2746';
export const CGI_TAG_ID = '800135c9495641d994b18344753c8f61'

//HSE MAIN PAGE 

export const DESIGN_TAG_ID = '450b65c195424392bafd2d1f6ffbf8ed';
export const ART_TAG_ID = '3baf5ce908d84cc2a8ac6c2fcc5a9c45';
export const FASHION_TAG_ID = '64e62f92b5874bb6b37a1062682dcea7';
export const JEWELRY_TAG_ID = 'ba14bd8702064ea48c3fddf572e225c3';

export const CANTEMPORARY_ART_TAG_ID = '5164b991a9d8469389175ceeb86d65b8';
export const PHOTOGRAPHY_ART_TAG_ID = 'e2108241611c4ee4861bb511faecdb5f';
export const VIDEO_ART_ART_TAG_ID = '36eb670a9e774a3eba96d0a6e080d064';
export const CURATOR_TAG_ID = 'a9b0cca1e0504713b73d8c4f9c85223c'

export const ADVERTISING_TAG_ID = '1b374fc6d2aa4f3696a3558b324bca31';
export const ART_DIRECTION_TAG_ID = 'ffa06d1b16b54abba2bbf6c8fb7eaf6d';
export const WEB_PUBLISH_TAG_ID = '89412f173a904356beb8e25f74ff2b73';
export const BOOK_DESIGN_TAD_ID = '2687fadaf0e048ed9925e56052f3010e';
export const BASIC_DESIGN_TA_ID = '0ea8c1fd2f6e49c3839c29fa10bc93b0';

export const COMMUNICATION_TAG_ID= '9bbc6e63198244efb2f6e586898f8f84';
export const NATURE_DESIGN_TAG_ID = '4f38a1e40a5f41cb9323dcbe3cea555d';
export const INTER_DESIGN_TAG_ID = '80fa55ae7d414e2eb90a170b62c1cce2';
export const CREATIVE_PROGRAMMING_TAG_ID= '36e3fd69fede4f9fb4f84d1be90a9e91';
export const DIGITAL_PRODUCT_TAG_ID= 'f0f14e99db1c4e25b889e87db45a73a0';
export const INTERACTIVE_DESIGN_TAG_ID= '269d0812d0d84d4ca64faaea4f3b88cc';
export const MEDIA_DESIGN_TAG_ID= '8972f434446b43c49dd0db38f5e8e376';
export const MODERN_DESIGN_TAG_ID = 'c670d2358d4940fb8fede85e9e084bc8';
export const OBJECT_DESIGN_TAG_ID = '47ae888ae5fe4343ad29999d04829b44';
export const PACKAGING_TAG_ID = '52644f0d0d9d4a2ea47192e70310ec12';
export const TYPE_TAG_ID = '55cc44daca804b979d067f9a59c56e00';
export const PRINT_PRODUCT_TAG_ID = '3ff5db4e9ed74d91869a35b36826fce3';
export const MANU_DESIGN_TAG_ID = 'd7cb4af8a1a861b2a25s79s914a2f2d8d';

export const RUSSIA_TAG_ID = '77b185c6f4ed4c1495cf8e165b0d1e5f';
export const EU_TAG_ID = 'eu';

//HSE LAB PAGE

export const HSELAB_DESIGN_TAG_ID = "450b65c195424392bafd2d1f6ffbf8ed_HSELAB"
export const EVENTS_DESIGN_TAG_ID = "a811d3a5afc04787a077199f1a969ad2"
export const BRAND_TAG_ID = '4f11ba61f96747f797c4d73421240810';
export const INTERIOR_TAG_ID = '070de8dee76e4712ac1f884d4275cb8e';
export const DESIGN_EDUCATION_TAG_ID = 'e0eee15578174c60863151f9ae9269c1';
export const REGIONS_TAG_ID = 'e0eee15578174c60863151f9ae9269c1';
export const PUBLIC_PLACE_ID = 'd82499c511b54aa195656cfb8eb52baf';
export const LANDSCAPING_TER_ID = 'b0479f308fb245c88020c5d884e2f7d6';
export const INTERIOR_DESIGN_TAG_ID = '80fa55ae7d414e2eb90a170b62c1cce2';


export const URBAN_ENVIRONMENT_ID = 'b5ecc76d50564c318b1ccd64fb257d9e';
export const TERRITORIAL_BRANDING_ID = '9237e556118a4585955a4d3342196a7d';
export const NATION_CRAFT_TAG_ID = '977b986e706b46ff9e8b809c700a9c5d';
export const CITIES_TAG_ID = 'dc762a78dac54369b91542bcbe86bb2a';
export const PLACES_TAG_ID = 'e0b6ceb6189b47e28c0257ae9f133d3d';


//Коллаб

export const COLAB_ID = 'cc1deeae3e7642d0858f6a39d553e370';
export const FASHION_COLAB_ID = 'f3e3a3f3bad345ef8dafb31667a24197';

//Издательство / книги

export const BOOK_DESIGN_ID = '2687fadaf0e048ed9925e56052f3010e';
export const MULTIPAGE_EDITION_ID = '549901e2e9f24e38a0b66bcbf7903c88';
export const CHILD_BOOK_ID = '1ea5957f54994f3b85450baf6837c134';
export const BOARD_GAME_ID = '334cd3a3f6584d0496b4a93179f42fc8';
export const VIMMELBUH_ID = 'ccfa83fc47bc44b78b6f077fcc403063';
export const CALENDAR_DESIGN_ID = 'beb0c95a01724cd0b4dd50d423f7f3d2';



//Галерея

export const CURATOR_ID = 'cfa985de99314540956c6703b4a866b3';
export const VIRTUAL_ID = 'e96d995e519740f1bf46d2f48a518555';
export const PICTURE_BOOK_ID = '0ea7259412644d8b830506f0fac2b08f';
export const PERFORMANS_ID = '04542772d26b4f21bcf963a06411826b';
export const PUBLIC_ART_ID = '75435409afdc4b9ca4615d1a4172688b';

export const GALLLLERY_ART_DIGITAL_COLLECTIONS_TAG_ID = '7eeaa5952fa8408ca9042ddbad24a542'; // цифровые коллекции
export const GALLLLERY_ART_COLLECTIONS_TAG_ID = 'df542139259049fc877f8ef761a83326'; // коллекции
export const GALLLLERY_ART_COLLECTING_TAG_ID = 'c88b2f098ff2456aae43e13d55876b04'; // коллекционирование
export const GALLLLERY_ART_ABOUT_COLLECTIONS_TAG_ID = 'e31b794d21364d87965942a45cab0ec0'; // о коллекционировании

/** Теги для табов «Проекты» / «Книги» в профиле Kiiids Art */
export const KIIIDS_ART_PROFILE_TAG_IDS = [
  '9d556f398293425da8cf551913e045c9',
  'b8f437190cc84e00b044542f91c661f2',
  'd5914f3b8bb547bab3cdd8ec0d6db1ec',
];

// категория исследования
export const RESEARCH_CATEGORY_ID = '5c0e423eed054a5b9970c54d1d9796fd';

//Визуальные исследования

export const DESIGN_HISTORY_ID = 'c578bf60a3c94a00a460022812834272';
export const ART_HISTORY_ID = 'd668fc391e9447f2b5a774d45a63b56f';

export const VISUAL_RES_TAG_ID_BL = 'b85dd5a16fcd41cf87e292d5733d660f';
export const VISUAL_RESEARCH_TAG_GRADUATION_BLACK = '3h8ecj38fk554a5j439bm4l4ch27dh3g';
export const VISUAL_RESEARCH_TAG_GRADUATION_WHITE = '3h8ecj38fk554a5j439bm4l4ch27dh3g';
export const VISUAL_RESEARCH_TAG_ASPIRANT = 'f9321d1337744e44831048435055ae54';
export const PRODUCT_RESEARCH_TAG = 'acb2f5d0e759439c8cd5aec44a1d8265';

//ALUMNI
export const EVENTS_TAD_ID = 'df1d2c2c367b429fa3c85b17132a73ad';
export const FANTASY_TAG_ID = '21b88acfd57f456985d37136a313f3cc';
export const SPACE_TAG_ID = '61857017874a45f5bfe698188fde91b0';
export const UNIVERSITY_TAG_ID = '009c939ebdc34eb4801246557e49979f';

//ART GEO
export const ARTIST_TAG_ID = 'b0b2ee60d6654ed7958c76af78f36b56';
export const GALLERYS_TAG_ID = '3baf5ce908d84cc2a8ac6c2fcc5a9c45_NEW';
export const HSE_ART_TAG_ID = '92a018084fac46f1b0e12646f8c1fda4';

/*______________ОРГАНИЗ____________ */
//HSE PERM
export const BASE_COURSE_ANIMATION_TAG_ID = '872a2bab9f6d4516b989755f72f03fbe';
export const GAME_DESIGN_TAG_ID = '56a474abc8e1448d96a536a9c584141f';
export const DESIGN_HSEPERM_TAG_ID = '450b65c195424392bafd2d1f6ffbf8ed_HSEPERM';
export const BASE_COMMUN_DESIGN_TAG_ID = '0ea8c1fd2f6e49c3839c29fa10bc93b0';

//PACKAGINGLAB
export const FOOD_PACKAGINGLAB_TAG = 'packaginglab_food_tag';
export const BEVERAGE_PACKAGINGLAB_TAG = 'packaginglab_beverage_tag';
export const BODY_PACKAGINGLAB_TAG = 'packaginglab_body_tag';
export const FOOD_PACKAGINGLAB_TAG_ID = '457816s3ab4ab22b129ad28sds4ac21e1';
export const BEVERAGE_PACKAGINGLAB_TAG_ID = '72751b12s628ab4a23d1e19asds4fc21';
export const BODY_PACKAGINGLAB_TAG_ID = '561cb4ab2f28a1a8sd52s78d994a21c4s';

//ADDCODINGHUB
export const ADCODINGHUB_TAG = 'adcodinghub_tag';

//AI LAB
export const AILAB_TAG = 'ailab_tag';
export const AI_TAG_ID = '2ed0d4a42307c1d9106e21a592e4704f';

//HSE FONTS 
export const HSEFONTS_TAG = 'hsefonts_tag';

//PRINTING HOUSE 
export const PRINTING_HOUSE_TAG = 'hseprintinghouse_tag';

//HSE MULTIMEDIA 
export const HSEMULTIMEDIA_TAG = 'hsemultimedia_tag';
export const EXPLAINERS_TAG_ID = '03eecb2abc0e47ac8ff99259ee35f27d';
export const TVDESIGN_TAG_ID = 'fa79ce7d6b5348faaad4695c53362aae';
export const MUSIC_CLIPS_TAG_ID = 'c0899462b2034748964b550c2a6e6a48';
export const DDD_POST_PROD_TAG_ID = 'v67b674c536843d7b987t9b397tb214f';

//TERBRANDING
export const TERBRANDING_TAG = 'terbranding_tag';

//HSE POSTER
export const HSEPOSTERLAB_TAG = 'hseposterlab_tag';
export const POSTER_TAG_ID = 'dddca0c7066a492a9ea553aca554ab7c';
export const AD_POSTER_TAG = '59a5a66097a340909a1476a65bff92d4';
export const SOCIAL_POSTER_TAG = '16592c4c71cf41fc8e5b9433075ebf4f';
export const THEATER_POSTER_TAG = '4499dff296ef4e66addc61295481ca82';

//HSE SCREENS
export const HSESCREENS_TAG = 'hsescreens_tag';

//HSECOLLECTIONS 
export const HSECOLLECTION_PORCELAIN_TAG = 'hsecollection_porcelain_tag';
export const HSECOLLECTION_TEXTILE_TAG = 'hsecollection_textile_tag';
export const HSECOLLECTION_SILCSCREEN_TAG = 'hsecollection_silcscreen_tag';
export const HSECOLLECTION_STORE_TAG = 'hsecollection_store_tag';
export const HSECOLLECTION_PRINT_TAG = 'hsecollection_print_tag';
export const HSECOLLECTION_CALENDARS_TAG = 'hsecollection_calendars_tag';

export const HSECOLLECTION_PORCELAIN_TAG_ID = '1783504c472b4ac38473855b083490ec';
export const HSECOLLECTION_TEXTILE_TAG_ID = 'ca97b342721e476aa6719b9e04919eac';
export const HSECOLLECTION_SILCSCREEN_TAG_ID = '51e780242cb6430385ca3c03e4fe038d';

export const HSECOLLECTION_CALENDARS_TAG_ID = '917a4684ad9541a0a80b8d1b84a8f8a8';

//HSEPHOTOLAB
export const HSEPHOTOLAB_TAG = 'hsephotolab_tag';

//EDUDESIGN
export const EDUDESIGN_TAG = 'edudesign_tag';
export const EDU_BRANDING_TAG_ID = 'a62f3c69ed474939aa9105590dbfdbf4';
export const CAMPUS_TAG_ID = 'cb97ab8c072a4f7abadd32e8116b4f65';



//CREATIVE
export const BASIC_DESIGN_COURSE_TAG_ID = '978saa51s67df76432e70310be98';
export const CREATIVE_BU_TAG_ID = '6ea17f37f26c40a3a606a1a0b1b33e1c';
export const TRANSPORT_TAG_ID = '8c430dfe72324740b4051ebb10d76867';
export const INDUSTRY_TAG_ID = '8a38819bf9c44033bf022b6031637e7a';
export const TOUR_TAG_ID = 'dc5606d3832840128de06f9249a8c330';
export const BRANDS_TAG_ID = '0e2dba66da304ceea31e119cd3144b6f';
export const HISTORY_INVESTIGATE_TAG_ID = 'cd99adea29d341f5b68485b3f9ff27db';

//PLACES
export const AUSTRIA_TAG_ID = '09533b9ebaeb4c3ba9a16265826d1eb1';
export const GB_TAG_ID = 'c54b14f23edf41008057afbdab87ff46';
export const GER_TAG_ID = 'bd99ff4af2234f25b7f29784b7d7934e';
export const IRL_TAG_ID = '612fa48d287946a2b16487d91a71e854';
export const LIHT_TAG_ID = 'a44e440072814423a95e3ed4c89ff4de';
export const LUX_TAG_ID = '619bd96bf5ec4e47b133daddadba5513';
export const FR_TAG_ID = '1556f863d9ee49778320847531954d27';
export const SWISS_TAG_ID = 'fa6b9656452f46d09b9327e68ed5c628';
export const ISL_TAG_ID = 'c92d427be8ef4c6ab4ed5626a4b0288a';
export const POL_TAG_ID = 'd1eb6d1ca28c446695352b5455f5d1f7';
export const NOWR_TAG_ID = '550ba04946db4e97879249284db7f980';
export const FINL_TAG_ID = 'ddda62b53d8a4d54860691c0c59eacfa';
export const SWE_TAG_ID = 'ce371d0aaa534f29b0f8a127ef2e2cc3';
export const SPAIN_TAG_ID = '07ea43a138f644ff94f9f5b8ec8a6d38';
export const IT_TAG_ID = '51178cbcd6e24c83a628125f3f798ca2';

//FOOD
export const FOOD_TAG_ID = '4e9f6f2a028e469893306a9c3e58c539';
export const RUS_FOOD_TAG_ID = 'f8446f2598b8426b8bd87917fe887c19';
export const GOR_FOOD_TAG_ID = '95eae18bc342465291d603cb29eb5810';
export const JAP_FOOD_TAG_ID = '78b3d2058a0a46cca13d8505b2c02027';
export const IT_FOOD_TAG_ID = 'bd9c90ec82814a0590e7a0cbf1a4bc7f';
export const FR_FOOD_TAG_ID = 'b9855d34aa3f43de815dcbca05f31bf1';
export const CHI_FOOD_TAG_ID = 'e221be608dd547b0ac7bd0f406ce537a';
export const SPA_FOOD_TAG_ID = 'bdb77f09a116495890e7c4372f6782ee';
export const MEX_FOOD_TAG_ID = '126cd4d4ac0d41ca9b76ffb1a6e2ac58';
export const IND_FOOD_TAG_ID = '0e52cc4e079b4a62af24b30bdcbbcf5d';
export const TUR_FOOD_TAG_ID = 'ec48cda820024a04baa027de2165348b';
export const AR_FOOD_TAG_ID = '57d0b5311bd8459994dcb09a70a873cc';
export const TAI_FOOD_TAG_ID = 'f81583951370453c8ea08ccaf2853fe3';
export const KOR_FOOD_TAG_ID = '583dbe0458da4cdcae9cfe0dcb579e07';
export const AFR_FOOD_TAG_ID = 'b3bf728ea8344c64bd56b68893cfadf0';
export const RESTAURANT_TAG_ID = '067e7fc3d51e44bf8d91ef7e02d6aa54';
export const CAFE_TAG_ID = '6c71101dc7bb48edaed9c519edf1e99a';
export const CONTEMPORARY_ART_TAG_ID = '5164b991a9d8469389175ceeb86d65b8';
 

//события
export const CONF_TAG_ID = '00a68ac85a0e474985d37136a313f3bb';
export const FEST_TAG_ID = '3859c2a874cd4fcc8982995bc23fffda';
export const PERFORMANCE_TAG_ID = 'e3fdeca5f3aa47f485300ea15eee4e9b';
export const THEATER_AND_PERF_TAG_ID = 'e1422025280f4aee8a6b69ecb78247e4';
export const SHADOW_THEATRE_TAG_ID = 'c0c4895b14e642b4a0fbc471d0d3a35c';
export const FESTIVAL_TAG_ID = 'd695b64fa924436197197838534cc829';
export const SHOW_TAG_ID = '6a8a43782ea04a2192d0418809d3666a';
export const EVENT_MANAGER_TAG_ID = '55aad37c3cac415791c3e5ccc6e98158';
export const MEDIA_STARTUP_TAG_ID = 'd4de303ca64349349889ce1fe6fdc1f6';
export const PRODUCER_TAG_ID = '92a5503dbafe48f482e7e281d687264c';
export const PERFORM_ART_TAG_ID = '422b4bcf2b2f41c9a73f72409c61e1ed';
export const BRAND_CONCEPT_TAG_ID = '1bb342481edf4c28b2ca1be17fa5cc7a';
export const ARCHITECT_TAG_ID = 'c1e7071d86004544a497fd305b38467c';

//RESEARCH
export const RESEARCH_TAG_ID = '5c0e423eed054a5b9970c54d1d9796fd';
export const THEMES_TAG_ID = 'a740e2f4ed044a7e81b6732f68bd74ac';
export const ALL_RESEARCH_TAG_ID = 'all_research';

//SOUND
export const SOUND_TAG_ID = '30e39c2e27fb430cbe541d94eb32d1ea';
export const SOUND_ART_TAG_ID = '30e39c2e27fb430cbe541d94eb32d1ea';

//---------Creative city

//Люди
export const PEOPLE_TAG_ID = 'db9d4954c3354147b496d8098b1cc096';

//Культура 
export const CULTURE_TAG_ID = 'culture_tag_id';
export const ARCH_TAG_ID = 'c1e7071d86004544a497fd305b38550d';
export const MUSEUM_NEW_TAG_ID = '370972265d64431f9b9a8d1085474ea5';
export const MUSEUM_TAG_ID = 'b233488ebb364517b0acfdece809b3b6';
export const LIBRARY_TAG_ID = '8ba964314ecd4d10b70693f5322605d1';
export const LIT_TAG_ID = '51069562a18341c2a968889727034174';
export const MUSIC_TAG_ID = '8db18d7413d74ab7a8e7aac29cfa3b25';
export const THEATRE_TAG_ID = '80f8067e3db745d3985740ccc30d3d5a';
export const EXPOSITION_TAG_ID = 'd85cb74227a841998fa2aa18843ad35b';

export const MUSEUM_BRANDING_TAG = '68204c511ef646fca24c45c662ad45b7';
export const MUSEUM_DESIGN_TAG = '83eaf8d8f9424d54809738bda258cbd7';

//Экономика
export const FINANCE_TAG_ID = '3d51f447146549d5b138dbf0fcdca198';

//Природа
export const NATURE_TAG_ID = '9cca20c1a528418a87c1698910fc4bc0';
export const ECOLOGY_TAG_ID = '3c9f57bafaf8441ca446b7cada10d271';
export const FLORA_AND_FAUNA_TAG_ID = '28d11df2496f42d0a31f4a76dd032a55';

//Спорт
export const SPORT_TAG_ID = 'de086b71f91b47fbab5b4e4c3a6ee311';

//Кулинария
export const CREATIVE_COOK_TAG_ID = 'cooking_tag_id';
export const COOKING_ID = '4e9f6f2a028e469893306a9c3e58c539';

//Праздники 
export const HOLIDAYS_TAG_ID = '4a2f0bd881284e9caa56df4d19432d0e';

//Менелдмент
export const MANAGEMENT_TAG_ID = 'management_tag_id';
export const BASE_DESIGN_COURSE = '978saa51s67df76432e70310be98';
export const CREATIVE_FUTURES_TAG_ID = '1d625ab4752s346f218asd3e19bcae1241';
export const FASHION_MANT_TAG_ID = 'fashion_managementidtag_id'
export const DESIGN_FUTURES_TAG_ID = 'design_futures_tag_id';
export const GAME_FUTURES_TAG_ID = 'game_futures_tag_id';
 
//CGLAB
export const D_PERSON_TAG_ID = '3753939a7998461cb5db26638e30ef6e';
export const D_MODEL_TAG_ID = '5c3ef460cb0a4f938afebfd883a62043';
export const VIDEO_GAME_TAG_ID = 'b3e32426e8ed45c38920e246c1ef9be0';
export const GAME_GRAPHIC_TAG_ID = '1e82c78705dd422588de261ca3c833ba';
export const ANIMATIC_TAG_ID = '1567199edb5e4baf8bfd84c4a5dd7a13';

//SOUND HSE
export const PRODUCTION_TAG = 'production_tag_id';
export const ARRANGEMENT_TAG_ID = '5077965390294678abe403b4bfc61c0c';
export const VOCAL_MUSIC_TAG_ID = 'cbadabb5401f40c0895335bbdfb9f463';
export const CLASSIC_MUSIC_TAG_ID = '085731fdb0cc407fa795477601fdb9aa';
export const MIX_TAG_ID = 'c4ba84b4c45d486a9a9f6e9a2ea9c05f';
export const MUSICAL_COMPOSITION_TAG_ID = 'c08eb0223c0346f8a5975f180dea871e';
export const MUSICAL_ALBUM_TAG_ID = '8f236b5d18b645c8bb297660eb75adf5';
export const POP_MUSIC_TAG_ID = '4f6c5853dc864ad6a7f35a0840921bb5';
export const ROCK_MUSIC_TAG_ID = '0f7e98cfdd6643538c26c21f57d8d160';
export const MIXING_AND_MASTERING_TAG_ID = '29650ab7f4e24346b3abde862b4c5442';
export const DANCING_MUSIC_TAG_ID = '9aabd60996494812bb8f9d6ec5cfcfeb';
export const INSTR_MUSIC_TAG_ID = '2eec68b59350449086b4f0bf68b3080a';

export const SOUND_PRODUCTION_TAG_ID = '1181e411d7c041db9814cb3e4cbc52d2';
export const MUSICAL_PROJECT_TAG_ID = 'ed8c09defea44566972b3415f62d3d0c';
export const STUDIO_RECORDING_TAG_ID = '4d216688eb4f44ff9ed423c2f664e51f';
export const ORCHESTRA_TAG_ID = 'dcd9c9f5378a418abfb8f0e9c40a4730';
export const PRESS_PACK_TAG_ID = 'f20edcf3c8f04b5598abd45f3b51cf18';
export const SOUND_SINTHESIS_TAG_ID = '2c9452a4159347359e3b0022f172a92d';
export const AUDIOMEDIA_TAG_ID = '8aeee03af2084ae6afdb3aa5c390fbb3';

export const SOUND_DESIGN_TAG = 'sound_design_tag_id';
export const SOUND_IDENTITY_TAG_ID = 'c7fac31f13e84a099d287f5dac833a18';
export const AUDIO_BRANDING_TAG_ID = 'eb8f149d8ef2469dae5be7331e856532';
export const SOUND_LIBRARY_TAG_ID = '8c6324f83161432eb1756c11b32956e0';
export const ANIMATION_MUSIC_TAG_ID = '726a44sd2154b63d1253cde21464cad194';
export const FILMS_MUSIC_TAG_ID = '726a44sd2154b63d1253cde21464cad193';
export const CATWALK_MUSIC_TAG_ID = '404c8a867aed4c50a62b3d944bd5e805';
export const ADVERTISING_MUSIC_TAG_ID = '1e2366394f8345fe904262f7b9eac785';
export const THEATRE_MUSIC_TAG_ID = '726a44sd2154b63d1253cde21464cad192';
export const PATCH_TAG_ID = '152f46e82b3e48a9b94c0b3a66a01931';
export const SOUND_TRACK_TAG_ID = '62d57b0a33f9490d9a179e824e19de0f';
export const BACKGROUND_MUSIC_TAG_ID = '9e9ddea7ef5c460caa7b99f0f86729b8';
export const FUNCTIONAL_MUSIC_TAG_ID = 'aa22168be44d4fac855cf43de85c516f';
export const SOUND_DESIGN_TAG_ID = '3c952dbe994742aea0ad2e2c6d22cba6'
export const BASE_COURSE_MODERN_DESIGN_TAG_ID = '140cdf7r1e3d8aq83e13qwedx14ba';

export const SOUND_ART_TAG = 'sound_art_tag_id';
export const SOUND_ALL_TAG = 'sound_all_tag-id';
export const SOUND_INSTALLATION_TAG_ID = 'b08893ecb1ba492f9d8fb0dbb532c9ec';
export const SOUND_SCULPTURE_TAG_ID = '514078bf2d0e46a5a2d938468a5b4864';
export const MULTI_INSTALLATION_TAG_ID = '5e590f63554146879aa20cc59834309d';
export const MULTIMEDIA_PERFORMANCE_TAG_ID = 'da215943b2aa47c49b84cc6a0d8806b3';
export const FIELD_RECORDS_TAG_ID = 'a9a1c45848aa4b3387d025cac5e6237a';
export const EXP_MUSIC_TAG_ID = 'ea318604d6ee4b7c961f8c7b60699250';
export const ELECTROACOUSTIC_MUSIC_TAG_ID = '97ad85557c6b4052aa6b6cd22ec08a8c';

export const SOUNDART_TAG_ID = 'e9e9e9278fa54708ba7e473383c8e39b';
export const NOISE_MUSIC_TAG_ID = 'dc1d6fa4b43740bfba32c5b822302a0b';
export const MUSIC_PRACTICE_TAG_ID = '18018226052142209f3d2a5e600d3d1d';
export const SOUNDSCAPE_TAG_ID = 'd045acaf08594097a6e099a14edbd051';
export const SONIFICATION_TAG_ID = '658ae9221ab54f0abe51bddf2d9cf70d';
export const ALHORITMIC_MUSIC_TAG_ID = 'f3f0013271e24c718a5c1a39832a4c48';
export const SOUND_POETRY_TAG_ID = 'dac19d25fd7c4635bf0db64ef9bc3e84';
export const MUSIC_CONCRETE_TAG_ID = '953bef3e80f64ef5ba1f53dbe2454749';

export const STUDIES_TAG = 'studies_tag_id';
export const SOUND_STUDIES_TAG_ID = '75e8252ef8134ca7a555cab6fad59895';
export const MUSICAL_CRITICISM = 'a3ff4048ab09452885cf0b7c1fc2c4b9';
export const SOUND_PHILOSOPHY = '30edfda170d14b59b004825c4ada05a6';
export const SOUND_ECOLOGY_TAG_ID = '3b1029f984dd458aa680e234ee197f37'

export const ABOUT_MUSIC_TAG_ID = '5f9874c63c814f9090a8a05634847da1'
export const MUSICIANS_TAG_ID = '3af0463f2dc342bab9e80a486187394e'

export const SOUNDLAB_TAG = 'sound_lab_tag_id';
export const MUSICAL_LABEL_TAG_ID = '6961eedbdbc54267aba10ee5b4bbc9f7';
export const SOUNDLAB_TAG_ID = '2f1deea7292a4441a66e56c8fe1e87ab';

export const ORIGINAL_FONT_TAG_ID = 'b21a771c9bca26f29sdaf4d2d88a5148a';

// HSE LMS

export const PRESENTAION_TAG_ID = '6878d529af2048a19d1f5d0d3ead2cc6';
export const EDUCATION_DESIGN_TAG_ID = '993cea0d707245d39455c29056a8f8f0';


export const FASHION_PHOTOGRAPHY_TAG_ID = '104062a4181242f1bfb9f0ac26ac6d95';
export const GAME_DEVELOPMENT_TAG_ID = '49eed1510eb9466296b337d0516bab94';

export const ABOUT_ART_TAG_ID = '325296fc9b3442c7b7ddbf0ef334d164';

export const AGEYTOMESH_LOGO_LENGTH = 182;